@if (updateAvailable()) {
  <div class="update-banner" role="alert">
    <app-icon name="zap" size="sm" />
    <span>{{ message() }}</span>
    <button class="btn-reload" (click)="reload()">Vernieuwen</button>
    <button class="btn-dismiss" (click)="dismiss()" aria-label="Sluiten">
      <app-icon name="x" size="xs" />
    </button>
  </div>
}
